import * as Sentry from '@sentry/react';
import { ENVIRONMENT } from '../config/environment';
import { version } from '../../package.json';
import { ReactNode, FC, ReactElement } from 'react';

// eslint-disable-next-line react-refresh/only-export-components
export function initObservability() {
  if (ENVIRONMENT.SENTRY_DSN) {
    Sentry.init({
      dsn: ENVIRONMENT.SENTRY_DSN,
      environment: ENVIRONMENT.ENV,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.2,
      release: version,
    });
  }
}

export interface ObservabilityProps {
  fallback: ReactElement;
  children: ReactNode;
}

export const ObservabilityWrapper: FC<ObservabilityProps> = ({ fallback, children }) => (
  <Sentry.ErrorBoundary fallback={fallback}>{children}</Sentry.ErrorBoundary>
);

// eslint-disable-next-line react-refresh/only-export-components
export const captureException: typeof Sentry.captureException = (exception, hint) => {
  let exceptionId = '';
  if (ENVIRONMENT.SENTRY_DSN) {
    exceptionId = Sentry.captureException(exception, hint);
  }
  return exceptionId;
};

// eslint-disable-next-line react-refresh/only-export-components
export const addBreadcrumb: typeof Sentry.addBreadcrumb = (breadcrumb, hint) => {
  if (ENVIRONMENT.SENTRY_DSN) {
    Sentry.addBreadcrumb(breadcrumb, hint);
  }
};
